import { Navigate, Outlet, useLocation } from "@umijs/max";
import React from "react";
import { permissionService } from "../core";

/**
 * 路由权限守卫组件
 * 用于保护需要权限验证的路由
 */
const PermissionRoute: React.FC = () => {
  const location = useLocation();

  // 检查当前路由是否有访问权限
  const hasPermission = permissionService.hasRoutePermission(location.pathname);

  if (!hasPermission) {
    return <Navigate to="/403" replace />;
  }

  return <Outlet />;
};

export default PermissionRoute;
